module.exports = __webpack_public_path__ + "img/Uneven Stone Height.b780c98b.png";